export enum ModelApiKey {
  Index = 'index',
  Page = 'page',
  Project = 'project',
  Location = 'location',
  Article = 'article'
}
